import { render, staticRenderFns } from "./my-profile-password-form.vue?vue&type=template&id=bdf29b0c&"
import script from "./my-profile-password-form.vue?vue&type=script&lang=js&"
export * from "./my-profile-password-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports